import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThunder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"thunder,zap, flash"} maskId="square-filled-radius-0-stroke-1-IconThunder"><path d="M16.9983 0.0712891L2.77344 13.9998H9.83588L6.99915 23.9284L21.2241 9.99984H14.1616L16.9983 0.0712891Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconThunder;
